export interface ContactTimelineStats {
    totalCalls: number;
    averageDuration: number;
    positivePercentage: number | null;
    lastContactAt: Date | null;
}
